module.exports = __webpack_public_path__ + "static/media/contestants.c87e0d06.svg";